export default __webpack_public_path__ + "static/media/zomato.b611e1f3.png";